module.exports = __webpack_public_path__ + "img/Ready3.420c66ab.jpg";